<h1 mat-dialog-title i18n="List Item|List Item details modal title@@list-item-details-modal-title">Details</h1>
<div mat-dialog-content #dialogContent>
  <list-item-details [data]="data"></list-item-details>

  <div *ngIf="data && data.actions && data.actions.length > 0" class="actions">
    <mat-divider class="full-width"></mat-divider>

    <h3 class="actions-title"
        i18n="List Item|List Item details modal Actions title@@list-item-details-modal-actions-title">Actions:</h3>

    <ng-container *ngFor="let action of data.actions">
      <app-button [label]="action.name"
                  class="action-btn"
                  [destructive]="action.code == 'delete' || action.code == 'reject'"
                  color="accent"
                  (clicked)="actionTriggered(action)"></app-button>
      <span class="btn-spacer"></span>
    </ng-container>
  </div>
</div>
<div mat-dialog-actions>
  <app-button label="Close"
              i18n-label="General|Close action label@@general-close-action-label"
              [disabled]="inProgress"
              [secondary]="true"
              (clicked)="proceed()"></app-button>
</div>
